/* Jhilke Studio homepage film (BV ad, 2026-10-04).
   A 15 second film of the four collections sits in its own square frame beside the hero copy. The poster image (the
   film's first frame) is in the page from the first paint. The film gets its source only when the frame is at least
   half on screen for the first time and the page has loaded (on a wide screen that is at load), then plays once,
   muted, and stops on its last frame. A button pauses it while it plays (WCAG 2.2.2) and goes away when it ends. It
   pauses while the frame is off screen and carries on when it is back.
   The film is never fetched for visitors who ask for reduced motion or Save-Data, or who are on a connection slower
   than 4g: they see the end-frame still instead (under reduced motion the picture element serves it directly). The
   same still replaces the film if it fails to load or the browser refuses to play it. */
(function () {
  'use strict';

  try {
    var video = document.querySelector('[data-jh-hero-video]');
    var poster = document.querySelector('[data-jh-hero-poster]');
    if (!video || !poster) return;

    var frame = video.closest('[data-jh-hero-frame]') || video.parentNode;
    var button = frame.querySelector('[data-jh-hero-pause]');
    var reduceQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var saveData = !!(connection && connection.saveData);
    var slow = !!(connection && connection.effectiveType && connection.effectiveType !== '4g');

    var loaded = document.readyState === 'complete';
    var visible = false;
    var started = false;
    var ended = false;
    var still = false;
    var userPaused = false;

    function hideButton() {
      if (button) button.hidden = true;
    }

    // The end-frame still takes the poster's place and the film goes away.
    function showEnd() {
      if (still) return;
      still = true;
      try { video.pause(); } catch (e) { /* nothing to stop */ }
      frame.classList.remove('is-playing');
      frame.classList.add('is-still');
      hideButton();
      var set = poster.getAttribute('data-end-srcset');
      var src = poster.getAttribute('data-end-src');
      if (set) poster.setAttribute('srcset', set);
      if (src) poster.setAttribute('src', src);
    }

    if (!reduceQuery || !('IntersectionObserver' in window)) { showEnd(); return; }
    if (reduceQuery.matches) { hideButton(); return; }
    if (saveData || slow) { showEnd(); return; }

    function pickSource() {
      var size = window.matchMedia('(max-width: 749px)').matches ? '720' : '1080';
      if (video.canPlayType('video/mp4; codecs="avc1.640028"')) return video.getAttribute('data-mp4-' + size);
      if (video.canPlayType('video/webm; codecs="vp9"')) return video.getAttribute('data-webm-' + size);
      return '';
    }

    function onShown() {
      if (ended || still) return;
      frame.classList.add('is-playing');
      if (button) button.hidden = false;
    }

    function onPlaying() {
      if (video.requestVideoFrameCallback) video.requestVideoFrameCallback(onShown);
      else onShown();
    }

    // It plays once: at the end it keeps its last frame on screen (no reset to the poster) and the button goes.
    function onEnded() {
      ended = true;
      frame.classList.remove('is-playing');
      frame.classList.add('has-ended');
      hideButton();
    }

    function refused(error) {
      // pause() during the first play() rejects it with AbortError; that is a pause, not a failure
      if (error && error.name === 'AbortError') return;
      showEnd();
    }

    function begin() {
      if (started || still || !loaded || !visible || reduceQuery.matches) return;
      var src = pickSource();
      if (!src) { showEnd(); return; }
      started = true;
      video.loop = false;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.preload = 'auto';
      video.addEventListener('playing', onPlaying, { once: true });
      video.addEventListener('ended', onEnded, { once: true });
      video.addEventListener('error', showEnd, { once: true });
      video.src = src;
      var attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(refused);
    }

    function sync() {
      if (!started || ended || still) return;
      if (visible && !userPaused && !document.hidden) {
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(refused);
      } else {
        video.pause();
      }
    }

    // Start (or carry on) when at least half the frame is on screen; pause only once it has left the screen.
    new IntersectionObserver(function (entries) {
      var entry = entries[entries.length - 1];
      if (entry.intersectionRatio >= 0.5) visible = true;
      else if (!entry.isIntersecting) visible = false;
      if (visible) begin();
      sync();
    }, { threshold: [0, 0.5] }).observe(frame);

    document.addEventListener('visibilitychange', sync);

    if (reduceQuery.addEventListener) {
      reduceQuery.addEventListener('change', function () {
        if (reduceQuery.matches) showEnd();
      });
    }

    if (button) {
      button.addEventListener('click', function () {
        userPaused = !userPaused;
        // fixed name "Pause the video"; aria-pressed says whether it is paused (roadmap DO, 2026-10-08)
        button.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        sync();
      });
    }

    if (!loaded) {
      window.addEventListener('load', function () {
        loaded = true;
        begin();
      }, { once: true });
    }
  } catch (error) {
    /* The film is decoration. The poster image is always there. */
  }
})();
